import { ToolbarItem } from '../../../common/components/ToolbarItem'
import { Mail } from 'lucide-react'
import { Tooltip } from '../../../common/components/Tooltip'

export const DirectMessagesItem = () => {
  // TODO: TBD later
  return (
    <Tooltip tooltipText="Coming soon">
      <ToolbarItem name="Direct Messages" Icon={Mail} variant="square" />
    </Tooltip>
  )
}
